import { SourcingEventStatus, type OrgDto, type SourcingEventV2Dto } from "../../../autogen/bff-api";
import { isBidDeadlinePassed } from "./supplierRows";

export type BidViewer = Pick<OrgDto, "canSeeDeliveredBidsBeforeDeadline">;

export const hasEarlyBidAccess = (event: SourcingEventV2Dto, viewer: BidViewer): boolean =>
  event.eventContext.type === "Private" && viewer.canSeeDeliveredBidsBeforeDeadline;

export const isBidContentUnsealed = (event: SourcingEventV2Dto, viewer: BidViewer): boolean =>
  isBidDeadlinePassed(event) || hasEarlyBidAccess(event, viewer);

export const isScoringOpen = (event: SourcingEventV2Dto, viewer: BidViewer): boolean =>
  event.status === SourcingEventStatus.Evaluation ||
  (event.status === SourcingEventStatus.Published && hasEarlyBidAccess(event, viewer));
